/**
 * @file guide of report Page
 * @author zhenglujie(zhenglujie@baidu.com))
 * Copyright (c) 2019-09-09 Baidu
 */

import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {setCurrentPage} from '../../actions/generalAction';
import tongjiRegister from '../../img/tongji-register.png';
import tongjiCode from '../../img/tongji-code.png';
import tongjiCreate from '../../img/tongji-create.png';
import tongjiManage from '../../img/tongji-manage.png';
import tongjiFAQ1 from '../../img/tongji-faq-1.png';
import tongjiID from '../../img/tongji-id.png';

import './index.less';

class GuideReport extends React.Component {
    linkToToken() {
        this.props.dispatch(setCurrentPage('token'));
    }
    render() {
        const risk1 = '当您的用户通过短网址跳转到您的页面，短网址服务会将该跳转流量推送指定百度统计账号，'
                    + '您的官网也可能将本次流量推送百度统计账号。那么可能会存在1个流量产生2条数据，导致统计数据出错的问题。';
        const risk2 = '将数据推送不同的百度统计账号，可以完美杜绝此类问题。故这里需要您申请新的百度统计账号'
                + '，用于开通短网址高级数据报表功能。';
        return (
            <div className="doc-container">
                <div className="guide-report-content">
                    <h2 className="title">申请流程</h2>
                    <h3>Step 1：新注册一个未使用的百度统计账号 （<a href="#faq2">为什么使用新账号，而不用已有账号？</a>）</h3>
                    <p>注册地址：<a target="_blank" href="https://tongji.baidu.com">https://tongji.baidu.com</a></p>
                    <img src={tongjiRegister}></img>
                    <h3>Step 2：新增2个网站用于展示分析短网址数据</h3>
                    <ul>
                        <li>新增网站用于：短网址跳转数据分析
                            <ul>
                                <li>{'网站域名：dwz.cn/users/{自定义英文名}/redirect'}</li>
                                <li>{'网站首页：dwz.cn/users/{自定义英文名}/redirect'}</li>
                                <li>{'网站名称：{自定义英文名}-跳转'}</li>
                            </ul>
                        </li>
                        <li>新增网站用于：短网址创建数据分析
                            <ul>
                                <li>{'网站域名：dwz.cn/users/{自定义英文名}/create'}</li>
                                <li>{'网站首页：dwz.cn/users/{自定义英文名}/create'}</li>
                                <li>{'网站名称：{自定义英文名}-创建'}</li>
                            </ul>
                        </li>
                    </ul>
                    <p>网站创建见下图：</p>
                    <img src={tongjiManage}></img>
                    <div className="tongji-create-div">
                        <img className="tongji-create-img" src={tongjiCreate}></img>
                    </div>

                    <h3 id="process3">Step 3：获取站点ID后请登录短网址控制台“高级报表”页面，填写站点ID后自动生效
                        <p>异常情况或上述方式无法开通也可发送高级报表申请邮件至
                            <a href="mailto:ext_dwz-help@baidu.com">ext_dwz-help@baidu.com</a>（仅对付费用户开通）
                        </p>
                    </h3>
                    <ul>
                        <li>标题：【申请高级报表】+ 公司名</li>
                        <li>内容：
                            <ul>
                                <li>短网址账号的信息
                                    <br/>
                                    <Link to="/console/userinfo" onClick={()=>this.linkToToken()}>Token</Link>：********
                                </li>
                                <li>关联百度统计账号的信息
                                    <br/>
                                    1. 用于短网址<strong>跳转</strong>数据分析的<a href="#faq3">网址ID</a>：********（文字+截图）
                                    <br/>
                                    2. 用于短网址<strong>创建</strong>数据分析的<a href="#faq3">网址ID</a>：********（文字+截图）
                                </li>   
                            </ul>
                        </li>
                    </ul>
                    <h2 className="title">FAQ</h2>
                    <ol>
                        <li>短网址的高级数据报表是怎么工作的？</li>
                        <img src={tongjiFAQ1}></img>
                        <ul>
                            <li>短网址通过您的申请流程（详见申请流程<a href="#process3">第三步</a>），确定统计数据录入的百度统计账号</li>
                            <li>您通过百度短网址服务创建短网址
                                <br/>短网址创建数据录入百度统计
                            </li>
                            <li>您将短网址推送给您的用户</li>
                            <li>您的用户（点击短网址\扫描二维码）访问短网址，跳转至目标页面
                                <br/>短网址跳转数据录入百度统计
                            </li>
                            <li>百度统计账号中生成数据报表</li>
                        </ul>
                        <li id="faq2">为什么使用新账号，而不用已有账号？</li>
                        <p>如果使用已有账号开通，存在以下错误统计数据的风险：
                            <br/>{risk1}
                            <br/>{risk2}
                        </p>
                        <li id="faq3">如何获取网站ID？</li>
                        <img src={tongjiCode}></img>
                        <img src={tongjiID}></img>
                        <p>绿框所示的字符串即为该网站的ID</p>
                    </ol>
                </div>
            </div>
            );
    }
}
export default connect(state => ({
    currentPage: state.currentPage
}))(GuideReport);
